"use client"

import { useRef, useState } from "react"
import { Check, Copy } from "lucide-react"

/** A first question as a chat bubble: tap it to copy, then paste it into a new chat. */
export function CopyBubble({ text, copyLabel = "Copy" }: { text: string; copyLabel?: string }) {
  const [copied, setCopied] = useState(false)
  const timer = useRef<number | undefined>(undefined)

  const copy = () => {
    navigator.clipboard?.writeText(text).catch(() => {
      // Blocked clipboard: the words stay on screen to type instead.
    })
    setCopied(true)
    window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => setCopied(false), 1600)
  }

  return (
    <button
      type="button"
      onClick={copy}
      aria-label={`${copyLabel}: ${text}`}
      className="group inline-flex max-w-full items-start gap-2 self-start rounded-[12px_12px_12px_4px] bg-[#1B2130] px-3 py-2 text-left text-sm leading-[1.4] text-white transition-colors hover:bg-[#262D3E] [@media(hover:none)]:active:opacity-70"
    >
      <span>{text}</span>
      <span aria-hidden className="mt-0.5 shrink-0 text-white/50 group-hover:text-white/80">
        {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
      </span>
    </button>
  )
}
